module.exports = {"en":{"search":"SEARCH"},"fr":{"search":"RECHERCHER"}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@adactive/arc-search/src/adsumSearch.lang.json
// module id = 222
// module chunks = 0